module.exports = __webpack_public_path__ + "img/step2-b.1c45b626.png";